// extracted by mini-css-extract-plugin
export var bounce = "_o4-1";
export var generatingText = "_o4-6";
export var lightning = "_o4-4";
export var popup = "_o4-5";
export var progressBar = "_o4-7";
export var progressFill = "_o4-8";
export var progressShimmer = "_o4-9";
export var progressText = "_o4-a";
export var shimmer = "_o4-3";
export var uploadIcon = "_o4-0";
export var uploadingText = "_o4-2";